// @core/api/endpoints/authz/list_objects.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListObjectsRequest,
  ListObjectsResponse,
} from '../../../types/authz';

const BASE_PATH = '/authz';

/**
 * List accessible objects
 * Returns all objects of a specified type that a user has access to with a given relation. Traverses the authorization graph to discover all accessible objects, useful for building filtered resource lists.
 */
export async function ListObjects(
  data: ListObjectsRequest,
  options?: RequestOptions
): Promise<ListObjectsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/objects/list`;
  const requestOptions = options;
  return client.post<ListObjectsResponse>(requestPath, data, requestOptions);
}
